module.exports = __webpack_public_path__ + "static/media/doc-4.f9fd30ae.jpg";